// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"pU-z","inlineTitle":"qU-z","sponsoredAdsWrapper":"rU-z","marketplaceRecosWrapper":"sU-z"};